<template>
  <transition name="fade">
    <div class="LeonDialog" @mousewheel.prevent="null" v-if="bol">
      <div class="LeonDialog_body" v-clickoutside="isShow">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LeonDialog',
  props: {
    bol: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isShow () {
      // console.log(123)
      this.$emit('update:bol', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.LeonDialog{
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.2);
  position: fixed;
  left: 0px;
  top: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/plugin/LeonDialog/src/main.vue